import gql from "graphql-tag"

const layoutWidgetsFragment = gql`
  fragment LayoutWidgetsFragment on LayoutWidgets {
    config {
      content {
        height
        type
        width
      }
      xpos
      ypos
    }
  }
`

export default layoutWidgetsFragment
